export default __webpack_public_path__ + "static/media/ins_200_women.9a002fc6.jpg";